import i18n from "../../../constants/i18n";
import { getPermissionIDRequired } from "../../../helpers/et3-has-permission";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import getCorePersonalStore from "../../../stores/core/core-personal-store";
import getDashBoardStore from "../../../stores/dashboard-store";
import ET3Div from "../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import HeaderMenuItem from "../HeaderMenuItem";
import {
  HEADER_MENU_GAP,
  HEADER_MENU_HEIGHT,
  HEADER_MENU_WIDTH
} from "../header-constants";

const KhattabaMenu = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitX } = theme;
  const userPermissions = getCorePersonalStore().userPermissions.get();
  const totalUnassignedNewClients =
    getDashBoardStore().totalUnassignedNewClients.get();
  const totalMaleUnreadMessages =
    getDashBoardStore().totalMaleUnreadMessages.get();
  const totalFemaleUnreadMessages =
    getDashBoardStore().totalFemaleUnreadMessages.get();
  const adminIsUnderMaintenance =
    getCorePersonalStore().adminUnderMaintenance.get();

  const isKhattabaAiAdmin = getCorePersonalStore().isKhattabaAiAdmin.get();

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={HEADER_MENU_WIDTH}
      height={HEADER_MENU_HEIGHT}
      fDirection="row"
      alignItems="center"
      justifyContent="flex-start"
      color={colors.all.transparent}
      style={{
        width: "100%",
        minWidth: 0,
        gap: HEADER_MENU_GAP * unitX
      }}
      onClick={() => {}}
    >
      {isKhattabaAiAdmin ? null : (
        <HeaderMenuItem
          isSelected={
            getCoreHistoryStore().getPageName() === "KHATTABAT_NEW_CLIENTS"
          }
          text={i18n.get("NEW_CLIENTS")}
          counter={`${totalUnassignedNewClients}`}
          link="/khattabat/newClients"
          enabled={
            userPermissions.indexOf(getPermissionIDRequired("Khatabat")) > -1 &&
            !adminIsUnderMaintenance
          }
        />
      )}
      <HeaderMenuItem
        isSelected={getCoreHistoryStore().getPageName() === "KHATTABAT_M"}
        text={i18n.get("MALE_CLIENTS")}
        counter={`${totalMaleUnreadMessages}`}
        link="/khattabat/Male"
        enabled={
          userPermissions.indexOf(getPermissionIDRequired("Khatabat")) > -1 &&
          !adminIsUnderMaintenance
        }
      />
      <HeaderMenuItem
        isSelected={getCoreHistoryStore().getPageName() === "KHATTABAT_F"}
        text={i18n.get("FEMALE_CLIENTS")}
        counter={`${totalFemaleUnreadMessages}`}
        link="/khattabat/Female"
        enabled={
          userPermissions.indexOf(getPermissionIDRequired("Khatabat")) > -1 &&
          !adminIsUnderMaintenance
        }
      />
      {isKhattabaAiAdmin ? null : (
        <HeaderMenuItem
          isSelected={
            getCoreHistoryStore().getPageName() === "KHATTABAT_MATCHING_RESULTS"
          }
          text={i18n.get("KHATTABAT_MATCHING_RESULTS")}
          counter={`${0}`}
          link="/khattabatMatching/results"
          enabled={
            userPermissions.indexOf(getPermissionIDRequired("Khatabat")) > -1 &&
            !adminIsUnderMaintenance
          }
        />
      )}
    </ET3Div>
  );
});

export default KhattabaMenu;
